module.exports = __webpack_public_path__ + "media/luxury-2026/estate-daytime-facade-b8010b91.jpg";